import LoadingButton from "@mui/lab/LoadingButton/LoadingButton";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Stack from "@mui/material/Stack/Stack";
import React, { useEffect, useState } from "react";
import { useDaoCollectionData } from "../libs/daoService";
import { LoadingProposal, ProposalCard } from "./Proposal";

const Zero = BigInt("0");
const One = BigInt("1");

const getProposals = (nextProposal: bigint, showingLast: number) => {
  const proposalIds: bigint[] = [];

  while (nextProposal > Zero && showingLast > 0) {
    showingLast -= 1;
    nextProposal -= One;
    proposalIds.push(nextProposal);
  }

  const hasNextPage = nextProposal > Zero;

  return { proposalIds, hasNextPage };
};

export const Proposals = React.memo(() => {
  const [showingLast, setShowingLast] = useState(5);

  const { data: nextProposal, isFetching } = useDaoCollectionData();

  useEffect(() => {
    if (isFetching) {
      setShowingLast(5);
    }
  }, [isFetching]);

  if (nextProposal === undefined) {
    return (
      <Stack spacing={4} sx={{ alignItems: "center", width: "100%", my: 2 }}>
        <LoadingProposal>
          <CircularProgress />
        </LoadingProposal>
      </Stack>
    );
  }

  if (nextProposal === Zero) {
    return (
      <Stack spacing={4} sx={{ alignItems: "center", width: "100%", my: 2 }}>
        <LoadingProposal>Empty</LoadingProposal>
      </Stack>
    );
  }

  const { proposalIds, hasNextPage } = getProposals(nextProposal, showingLast);

  return (
    <Stack spacing={4} sx={{ alignItems: "center", width: "100%", my: 2 }}>
      {proposalIds.map((id) => (
        <ProposalCard key={id.toString()} proposalId={id} />
      ))}
      {hasNextPage && (
        <LoadingButton
          onClick={() => setShowingLast((value) => value + 5)}
          variant="outlined"
        >
          Next
        </LoadingButton>
      )}
    </Stack>
  );
});
